import Form from './Form';
import PageCoverAndLogo from './PageCoverAndLogo';

export default Object.assign(PageCoverAndLogo, { Form });
